/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterFixedAssetFilter,
  PresenterOneFixedAssetResponse,
  PresenterResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Search<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Get the fixed assets list, can be used to retrieve event history. For AI agents, defaults apply: filter[calculate_cost] = true. Unless explicitly stated, default use filter[include_history] = false. If user provide asset code in this format 'SSKM012-001', you must extract to use asset code 'SSKM012', branch code '001'. Some filter will use the code or biid, but user might use the name instead. If you're unclear which one to use, ask the user for clarification.
   *
   * @tags search
   * @name PostSearchFixedAssets
   * @summary Get the fixed assets list.
   * @request POST:/search/fixed_assets
   */
  postSearchFixedAssets = (
    body: PresenterFixedAssetFilter,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneFixedAssetResponse[];
      },
      any
    >({
      path: `/search/fixed_assets`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
